import { create } from "zustand";

export type Theme = "light" | "dark";
const KEY = "sk-theme";

/** Thème clair par défaut ; le sombre est un choix du joueur, gardé sur l'appareil. */
function read(): Theme {
  try {
    return localStorage.getItem(KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light"; // navigation privée
  }
}

function apply(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  // Couleur de la barre du navigateur, assortie au fond de l'écran.
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", theme === "dark" ? "#0e0e22" : "#f4f5fb");
}

export const useTheme = create<{ theme: Theme; setTheme: (t: Theme) => void }>((set) => ({
  theme: read(),
  setTheme: (theme) => {
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      /* navigation privée : le choix vaut pour la session */
    }
    apply(theme);
    set({ theme });
  },
}));

apply(read());
